import { OMSResource, OMSShiftType } from '@/api/apis/resources/schedule';

export enum OMSShiftOptionType {
  OnCall = OMSShiftType.OnCall,
  OnCallVoluntary = 'OnCallVoluntary',
  AdminDay = OMSShiftType.AdminDay,
  NoCall = OMSShiftType.NoCall,
  SickLeave = OMSShiftType.SickLeave,
  Unavailable = OMSShiftType.Unavailable,
  Vacation = OMSShiftType.Vacation,
}

export enum OMSSchedulerViewType {
  Scheduler = 'scheduler',
  Duty = 'duty',
  Personal = 'personal',
}

export type OMSOnCallResource = OMSResource & {
  slotIndex: number;
  isVoluntary?: boolean;
};
